import { DataLoaderParams } from '@/types/DataLoaderParams';
import { fetchCatalogDetailsIfNeeded } from '@/redux/modules/catalogDetail';
import { fetchCatalogsIfNeeded } from '@/redux/modules/catalog/catalog.actions';
import { getIdFromPath } from '@/utils/urls';

export default ({ location, store }: DataLoaderParams) => {
    const { dispatch } = store;
    const { pathname } = location;
    const catalogId = getIdFromPath(pathname);
    return Promise.all([
        dispatch(fetchCatalogsIfNeeded({ catalogIds: [catalogId] })),
        dispatch(fetchCatalogDetailsIfNeeded([catalogId])),
    ]);
};
